
export enum StatusRecurso{
    CRIADO = "Criado",
    RECUSADO = "Recusado",
    ACEITO = "Aceito"
}

interface CandidatoEdital {
    id: string;
    inscricao: string;
    candidatoId: string;
    editalId: string;
    nomeEdital: string;
}

export interface Recurso{
    id?: string;
    texto: string;
    candidatoId?: string;
    bancaId?: string;
    status: StatusRecurso;
    dataCriacao: string;
    nomeCandidato?: string;
    candidatoInscricao?: string;
    candidatoEditais?: CandidatoEdital[];
}